import React from "react";
import { DeviceInterface } from "../../../../store/mine_craft/devicesSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";

import Title from "./_Title";
import Meta, { MetaInterface } from "../../../../componets/Meta";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface _MetaInterface {
  device: DeviceInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
  about?: boolean;
  className?: string;
}

const _Meta = ({ device, shape, size, about, className }: _MetaInterface) => {
  if (!device) {
    return null;
  }

  const Icon = ({ icon }: { icon: any }) => <FontAwesomeIcon icon={icon} />;

  const renderDescription = () => (
    <>
      <small>{`Seen: ${formattedDate(device.updated_at).fromNow}`}</small>
      {about && <div className='v-device-about'><small>{device.vendor}</small></div>}
    </>
  )

  const DeviceIcon = () => {
    if(device.device_type === 'iPad') {
      return <Icon icon={"fa-solid fa-tablet"} />
    } else {
      return <Icon icon={"fa-solid fa-mobile"} />
    }
  }

  return (
    <Meta
      url={device.url}
      size={size}
      shape={shape}
      fallback={DeviceIcon}
      title={<Title name={device.id} bannedUntil={device.banned_until} />}
      description={renderDescription()}
      className={className}
    />
  );
}

export default _Meta;
